module.exports = __webpack_public_path__ + "img/Qkong2.8e16e80c.png";